<template>
  <div class="option-item">
    <div class="quantity">
      <h5 class="text-size">{{ item.quantity }} x</h5>
    </div>
    <div class="name">
      <h5 class="text-size">{{ item.name }} ({{ item.price }})</h5>
    </div>
    <div class="price">
      <h5 class="text-size">${{ this.getPrice(item) }}</h5>
    </div>
  </div>
</template>
<script>
export default {
  name: "CheckoutOptionItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    getPrice(item) {
      const subTotal = parseFloat(item.price) * item.quantity;
      return (Math.round(subTotal * 100) / 100).toFixed(2);
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.option-item {
  display: flex;
  flex-direction: row;
  color: rgb(39, 50, 57);
  padding: 0vw 12vw 0vw 8vw;
}
.text-size {
  font-size: 14px;
}
.quantity {
  width: 10%;
  line-height: 20px;
  font-size: 14px;
  color: rgb(39, 50, 57);
}
.name {
  display: flex;
  flex-direction: column;
  flex: 4 1 0%;
}
.price {
  flex: 1 1 0%;
  text-align: right;
  font-size: 15px;
  line-height: 20px;
}
.name-label {
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  padding-bottom: 4px;
  color: rgb(39, 50, 57);
}
.price-label {
  color: rgb(39, 50, 57);
  width: 100%;
  height: 20px;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/Components/CheckoutOptionItem.vue